import {
    GetSecretValueCommand,
    GetSecretValueResponse,
    SecretsManagerClient,
    SecretsManagerClientConfig
  } from '@aws-sdk/client-secrets-manager';
  import { fromCognitoIdentityPool } from '@aws-sdk/credential-providers';
  import { Auth } from 'aws-amplify';
  import { SECRET_KEY_ARN_CONFIG, GRAPHQL_CONFIG, MJE_GRAPHQL_CONFIG, S3_CONFIG, APIGATEWAY_CONFIG, QUICKSIGHT_DASHBOARD_CONFIG, MJE_S3_CONFIG, FRISCO_S3_CONFIG, LOGICO_S3_CONFIG, FLEXICO_GRAPHQL_CONFIG, FLEXICO_S3_CONFIG, APPSYNC_PLUS_GRAPHQL_CONFIG, TANC_S3_CONFIG, FS_S3_CONFIG, RECONCENTRAL_GRAPHQL_CONFIG, TASK_MANAGER_GRAPHQL_CONFIG } from 'src/constants/AppConstants';

  export async function getToken() {
    const currentSession = await Auth.currentSession();
    return currentSession.getIdToken().getJwtToken();
  }
  
  export async function getCredentialsFromAWSService() {
    const COGNITO_LOGIN: any = {};
    const REGION = 'us-west-2';
    const CognitoIdentityPoolId = 'us-west-2:df384e64-fc44-42dc-bfcd-f726ae6f4f30';
    COGNITO_LOGIN[getCognitoDomain()] = await getToken();
    return fromCognitoIdentityPool({
      clientConfig: { region: REGION },
      identityPoolId: CognitoIdentityPoolId,
      logins: COGNITO_LOGIN
    });
  }
  
  function getCognitoDomain() {
    const REGION = 'us-west-2';
    const USER_POOL_ID = 'us-west-2_ktI8D0rjG';
    return 'cognito-idp.' + REGION + '.amazonaws.com/' + USER_POOL_ID;
  }
  
  export const retrieveAPIKey = async (): Promise<GetSecretValueResponse> => {
    const REGION = 'us-west-2';
    const Stage = 'beta';
    const SECRET_MANAGER_ARN = SECRET_KEY_ARN_CONFIG.find((c) => c.environment === Stage)?.secretARN;
    const secretsManageClientConfig: SecretsManagerClientConfig = {
      region: REGION,
      credentials: await getCredentialsFromAWSService()
    };
    const secretsManagerClient = new SecretsManagerClient(secretsManageClientConfig);
    const command = new GetSecretValueCommand({ SecretId: SECRET_MANAGER_ARN });
    return await secretsManagerClient.send(command);
  };

  export const mjeRetrieveAPIKey = async (): Promise<GetSecretValueResponse> => {
    const REGION = 'us-west-2';
    const Stage = 'beta';
    const SECRET_MANAGER_ARN = SECRET_KEY_ARN_CONFIG.find((c) => c.environment === Stage)?.secretARN;
    const secretsManageClientConfig: SecretsManagerClientConfig = {
      region: REGION,
      credentials: await getCredentialsFromAWSService()
    };
    const secretsManagerClient = new SecretsManagerClient(secretsManageClientConfig);
    const command = new GetSecretValueCommand({ SecretId: SECRET_MANAGER_ARN });
    return await secretsManagerClient.send(command);
  };

  export const retrieveAGGridLicenseKey = async (): Promise<GetSecretValueResponse> => {
    const REGION = 'us-west-2';
    const Stage = 'beta';
    const SECRET_MANAGER_ARN = SECRET_KEY_ARN_CONFIG.find((c) => c.environment === Stage)?.secretARN;
    const secretsManageClientConfig: SecretsManagerClientConfig = {
      region: REGION,
      credentials: await getCredentialsFromAWSService()
    };
    const secretsManagerClient = new SecretsManagerClient(secretsManageClientConfig);
    const command = new GetSecretValueCommand({ SecretId: SECRET_MANAGER_ARN });
    return await secretsManagerClient.send(command);
  };

  export const getAppSyncConfig = async () => {
    try {
      const Stage = 'beta';
      const grapQLEndPoint = GRAPHQL_CONFIG.find((c) => c.environment === Stage)?.grapQLEndPoint;      
      return {
        Appsync: {
          aws_appsync_graphqlEndpoint: grapQLEndPoint, // TODO - will be replaced from aws secrets
          aws_appsync_region: 'us-east-1',
          aws_appsync_authenticationType: 'AMAZON_COGNITO_USER_POOLS'
        }
      };
    } catch (error) {
      console.error('Unable to retrieve API Key ', error);
      throw error;
    }
  };

  export const getMJEAppSyncConfig = async () => {
    try {
      const Stage = 'beta';
      const grapQLEndPoint = MJE_GRAPHQL_CONFIG.find((c) => c.environment === Stage)?.grapQLEndPoint;
      return {
        Appsync: {
          aws_appsync_graphqlEndpoint: grapQLEndPoint, // TODO - will be replaced from aws secrets
          aws_appsync_region: 'us-east-1',
          aws_appsync_authenticationType: 'AMAZON_COGNITO_USER_POOLS',
        }
      };
    } catch (error) {
      console.error('Unable to retrieve API Key ', error);
      throw error;
    }
  };


  export const getFlexicoAppSyncConfig = async () => {
    try {
      const Stage = 'beta';
      const grapQLEndPoint = FLEXICO_GRAPHQL_CONFIG.find((c) => c.environment === Stage)?.grapQLEndPoint;
      return {
        Appsync: {
          aws_appsync_graphqlEndpoint: grapQLEndPoint, 
          aws_appsync_region: 'us-east-1',
          aws_appsync_authenticationType: 'AMAZON_COGNITO_USER_POOLS',
        }
      };
    } catch (error) {
      console.error('Unable to configure appsync ', error);
      throw error;
    }
  };

  export const getAppSyncPlusConfig = async () => {
    try {
      const Stage = 'beta';
      const grapQLEndPoint = APPSYNC_PLUS_GRAPHQL_CONFIG.find((c) => c.environment === Stage)?.grapQLEndPoint;
      return {
        Appsync: {
          aws_appsync_graphqlEndpoint: grapQLEndPoint, 
          aws_appsync_region: 'us-east-1',
          aws_appsync_authenticationType: 'AMAZON_COGNITO_USER_POOLS',
        }
      };
    } catch (error) {
      console.error('Unable to configure appsync ', error);
      throw error;
    }
  };

  export const getS3Config =  () => {
    try {
      const Stage = 'beta';

      const bucket = S3_CONFIG.find((c) => c.environment === Stage)?.bucket;
      const region = S3_CONFIG.find((c) => c.environment === Stage)?.region;
      return {
        S3: {
          aws_user_files_s3_bucket: bucket,
        aws_user_files_s3_bucket_region: region
        }
      };
    } catch (error) {
      console.error('Some Error Occured ', error);
      throw error;
    }
  };

  export const getMJES3Config =  () => {
    try {
      const Stage = 'beta';

      const bucket = MJE_S3_CONFIG.find((c) => c.environment === Stage)?.bucket;
      const region = MJE_S3_CONFIG.find((c) => c.environment === Stage)?.region;
      return {
        S3: {
          aws_user_files_s3_bucket: bucket,
        aws_user_files_s3_bucket_region: region
        }
      };
    } catch (error) {
      console.error('Some Error Occured ', error);
      throw error;
    }
  };

  export const getFriscoS3Config =  () => {
    try {
      const Stage = 'beta';

      const bucket = FRISCO_S3_CONFIG.find((c) => c.environment === Stage)?.bucket;
      const region = FRISCO_S3_CONFIG.find((c) => c.environment === Stage)?.region;
      return {
        S3: {
          aws_user_files_s3_bucket: bucket,
        aws_user_files_s3_bucket_region: region
        }
      };
    } catch (error) {
      console.error('Some Error Occured ', error);
      throw error;
    }
  };

  export const getLogicoS3Config =  () => {
    try {
      const Stage = 'beta';

      const bucket = LOGICO_S3_CONFIG.find((c) => c.environment === Stage)?.bucket;
      const region = LOGICO_S3_CONFIG.find((c) => c.environment === Stage)?.region;
      return {
        S3: {
          aws_user_files_s3_bucket: bucket,
        aws_user_files_s3_bucket_region: region
        }
      };
    } catch (error) {
      console.error('Some Error Occured ', error);
      throw error;
    }
  };

  export const getFlexicoS3Config =  () => {
    try {
      const Stage = 'beta';

      const bucket = FLEXICO_S3_CONFIG.find((c) => c.environment === Stage)?.bucket;
      const region = FLEXICO_S3_CONFIG.find((c) => c.environment === Stage)?.region;
      return {
        S3: {
          aws_user_files_s3_bucket: bucket,
        aws_user_files_s3_bucket_region: region
        }
      };
    } catch (error) {
      console.error('Some Error Occured ', error);
      throw error;
    }
  };

  export const getTANCS3Config =  () => {
    try {
      const Stage = 'beta';

      const bucket = TANC_S3_CONFIG.find((c) => c.environment === Stage)?.bucket;
      const region = TANC_S3_CONFIG.find((c) => c.environment === Stage)?.region;
      return {
        S3: {
          aws_user_files_s3_bucket: bucket,
        aws_user_files_s3_bucket_region: region
        }
      };
    } catch (error) {
      console.error('Some Error Occured ', error);
      throw error;
    }
  };

  export const getFSS3Config =  () => {
    try {
      const Stage = 'beta';

      const bucket = FS_S3_CONFIG.find((c) => c.environment === Stage)?.bucket;
      const region = FS_S3_CONFIG.find((c) => c.environment === Stage)?.region;
      const uploadsBucket = FS_S3_CONFIG.find((c) => c.environment === Stage)?.secondaryBucket;
      return {
        S3: {
          aws_user_files_s3_bucket: bucket,
        aws_user_files_s3_bucket_region: region,
        uploads_bucket: uploadsBucket
        }
      };
    } catch (error) {
      console.error('Some Error Occured ', error);
      throw error;
    }
  };

  export const getAPIGateWayConfig =  () => {
    try {
      const Stage = 'beta';

      const ApiEndpoint = APIGATEWAY_CONFIG.find((c) => c.environment === Stage)?.ApiGateWayEndpoint;
      return {
        APIGateWay: {
          ApiGateWayEndpoint: ApiEndpoint
        }
      };
    } catch (error) {
      console.error('Some Error Occured ', error);
      throw error;
    }
  };

  export const getQuicksightDashboardConfig =  () => {
    try {
      const Stage = 'beta';

      const url = QUICKSIGHT_DASHBOARD_CONFIG.find((c) => c.environment === Stage)?.url;
      return {
        dashboard: {
          url: url
        }
      };
    } catch (error) {
      console.error('Some Error Occured ', error);
      throw error;
    }
  };


  export const callGenericGraphQLDirect = async (query: string, variables: Record<string, any> = {}) => {
    const config = await getAppSyncConfig();
    const endpoint = config.Appsync.aws_appsync_graphqlEndpoint;
    if (!endpoint) throw new Error('GraphQL endpoint not configured');
    const token = await getToken();

    const response = await fetch(endpoint, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': token,
      },
      body: JSON.stringify({ query, variables })
    });

    const result = await response.json();
    if (result.errors) {
      throw { errors: result.errors, data: result.data };
    }
    return { data: result.data };
  };

export const callPlusGraphQLDirect = async (query: string, variables: Record<string, any> = {}) => {
  const config = await getAppSyncPlusConfig();
  const endpoint = config.Appsync.aws_appsync_graphqlEndpoint;
  if (!endpoint) throw new Error('AppSync Plus GraphQL endpoint not configured');
  const token = await getToken();

  const response = await fetch(endpoint, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': token,
    },
    body: JSON.stringify({ query, variables })
  });

  const result = await response.json();
  if (result.errors) {
    throw { errors: result.errors, data: result.data };
  }
  return { data: result.data };
};


  export const getReconcentralAppSyncConfig = async () => {
    try {
      const Stage = 'beta';
      const grapQLEndPoint = RECONCENTRAL_GRAPHQL_CONFIG.find((c) => c.environment === Stage)?.grapQLEndPoint;
      return {
        Appsync: {
          aws_appsync_graphqlEndpoint: grapQLEndPoint,
          aws_appsync_region: 'us-east-1',
          aws_appsync_authenticationType: 'AMAZON_COGNITO_USER_POOLS',
        }
      };
    } catch (error) {
      console.error('Unable to configure Reconcentral AppSync', error);
      throw error;
    }
  };

  export const callReconcentralGraphQL = async (query: string, variables: Record<string, any> = {}) => {
    const config = await getReconcentralAppSyncConfig();
    const endpoint = config.Appsync.aws_appsync_graphqlEndpoint;
    if (!endpoint) throw new Error('Reconcentral GraphQL endpoint not configured');
    const token = await getToken();

    const response = await fetch(endpoint, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': token,
      },
      body: JSON.stringify({ query, variables })
    });

    const result = await response.json();
    if (result.errors) {
      throw { errors: result.errors, data: result.data };
    }
    return { data: result.data };
  };

  // Task Manager dedicated AppSync API (TaskManagerStack, Cognito user-pool auth).
  export const getTaskManagerAppSyncConfig = async () => {
    try {
      const Stage = 'beta';
      const grapQLEndPoint = TASK_MANAGER_GRAPHQL_CONFIG.find((c) => c.environment === Stage)?.grapQLEndPoint;
      return {
        Appsync: {
          aws_appsync_graphqlEndpoint: grapQLEndPoint,
          aws_appsync_region: 'us-east-1',
          aws_appsync_authenticationType: 'AMAZON_COGNITO_USER_POOLS',
        }
      };
    } catch (error) {
      console.error('Unable to configure Task Manager AppSync', error);
      throw error;
    }
  };

  // Task Manager calls retry transient failures (network errors, HTTP 429/5xx)
  // with exponential backoff. GraphQL-level errors (validation/authz) are not
  // retried since they are deterministic and won't succeed on a retry.
  const TASK_MANAGER_MAX_RETRIES = 3;
  const TASK_MANAGER_RETRY_BASE_DELAY_MS = 300;

  const isRetryableHttpStatus = (status: number) => status === 429 || status >= 500;

  const sleep = (ms: number) => new Promise((resolve) => setTimeout(resolve, ms));

  export const callTaskManagerGraphQLDirect = async (query: string, variables: Record<string, any> = {}) => {
    const config = await getTaskManagerAppSyncConfig();
    const endpoint = config.Appsync.aws_appsync_graphqlEndpoint;
    if (!endpoint) throw new Error('Task Manager GraphQL endpoint not configured');

    let lastError: any;
    for (let attempt = 0; attempt <= TASK_MANAGER_MAX_RETRIES; attempt++) {
      try {
        // Refresh the token each attempt in case it expired between retries.
        const token = await getToken();
        const response = await fetch(endpoint, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': token,
          },
          body: JSON.stringify({ query, variables })
        });

        if (!response.ok) {
          // Retry transient HTTP failures; fail fast on client errors (4xx).
          if (isRetryableHttpStatus(response.status) && attempt < TASK_MANAGER_MAX_RETRIES) {
            lastError = new Error(`Task Manager GraphQL request failed with status ${response.status}`);
            await sleep(TASK_MANAGER_RETRY_BASE_DELAY_MS * Math.pow(2, attempt));
            continue;
          }
          throw new Error(`Task Manager GraphQL request failed with status ${response.status}`);
        }

        const result = await response.json();
        if (result.errors) {
          // GraphQL errors are deterministic — surface immediately, no retry.
          throw { errors: result.errors, data: result.data };
        }
        return { data: result.data };
      } catch (error: any) {
        // Don't retry GraphQL-level errors (they carry an `errors` array).
        if (error && error.errors) {
          throw error;
        }
        lastError = error;
        if (attempt < TASK_MANAGER_MAX_RETRIES) {
          await sleep(TASK_MANAGER_RETRY_BASE_DELAY_MS * Math.pow(2, attempt));
          continue;
        }
        throw lastError;
      }
    }
    throw lastError;
  };
